/** Представление списка элементов http://www.w3.org/ns/adms#AssetDistribution.
 * Для http://www.w3.org/ns/adms#Asset элементы задаются в http://www.w3.org/ns/dcat#distribution
 *
 *  Для отображения используется List (см. https://ant.design/components/list/),который содержит:
 * 1. Заголовок - заголовок AssetDistribution (см. http://purl.org/dc/terms/title)
 * 2. Описание - Описание  (см. http://purl.org/dc/terms/description)
 * 
 * 3. Входным параметром является массив distribution[], содержащий URI элементов
 * 
 */
import React from 'react';
import i18n from "i18next";
import { connect } from 'react-redux'
import { List, Button, Modal, message } from 'antd';
import { EditOutlined, FileAddOutlined } from '@ant-design/icons'
import { subsetByLang, getLangValue, updateTripletsByObjectValue } from '../../virtuoso/helper';
import {AssetDistributionListItem} from './AssetDistributionSmall';
import AssetDistributionCard from './AssetDistributionCard';
import { AdmsAsset, RdfTriplet } from '../../redux';
import { DMLActions } from '../../redux';
import FileSelectPage from '../dml/FileSelectPage';
import NewElement from '../editor/NewElement';
import { makeHashLastInURI, parseFileNameFromURL} from '../../utils/uriUtil';
import settings from '../../virtuoso/settings';
import moment from 'moment';

const { confirm } = Modal;

const showViewDetail = (formRef=f=>f, selected, factory, history, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("AssetDistributions.js showViewDetail", selected, factory, history);
	return <Modal style={{minWidth: "80%"}} open={true} 
          title={i18n.t('components.adms.distribution.show.title')}
          cancelText={i18n.t('components.adms.distribution.show.cancelText')}
          okText={i18n.t('components.adms.distribution.show.okText')} 
          onCancel={onCancelOperation} onOk={onFinishOperation}	cancelButtonProps={{ disabled: true, style: {display: "none" }}}>
      <AssetDistributionCard IRI={selected} factory={factory} history={history}/>
 	  </Modal>
}

const showEditDetail = (formRef=f=>f, selected, factory, history, onFinishOperation=f=>f, onCancelOperation=f=>f, operation='view') => {
	//console.log("syncPercent", selected, factory, history);
	return <Modal style={{minWidth: "80%"}} open={true} 
          title={i18n.t('components.adms.distribution.show.title')}
          cancelText={i18n.t('components.adms.distribution.show.cancelText')}
          okText={i18n.t('components.adms.distribution.show.okText')} 
          onCancel={onCancelOperation} onOk={onFinishOperation}	cancelButtonProps={{ disabled: true, style: {display: "none" }}}>
      <AssetDistributionCard IRI={selected} factory={factory} history={history} operation={operation}/>
 	  </Modal>
}

const showAdd = (formRef=f=>f, onFinishOperation=f=>f, onCancelOperation=f=>f, selected) => {
  //console.log("syncPercent", syncPercent);
  const isFile = (selected) && (selected.fileEntryId);
  const okButtonProps={disabled: !isFile};
	return (
    <Modal style={{minWidth: 700}} open={true} 
        title={i18n.t('components.adms.distribution.add.title')}
        cancelText={i18n.t('components.adms.distribution.add.cancelText')}
        okText={i18n.t('components.adms.distribution.add.okText')} 
        onCancel={onCancelOperation} onOk={onFinishOperation} okButtonProps={okButtonProps}>	
      <FileSelectPage wrappedComponentRef={formRef} />
	  </Modal>
  )
}

/**
 * Отобразить диалог для создания нового распространения.
 * Варианты заполнение 1-запрос к EndPoint, 2-имя файла:
 * 1. Формирование URI на основе URI карточки с добавлением #Distribution+Текущая дата и время
 *    Формирование наименование "SPARQL запрос"
 *    Формирование accessURL на основе настройки virtuoso+SPARQL (construct {?s ?p ?o} where {?s ?p ?o})+имя графа в виде URI карточки
 *    Формирвоание описание с содержимым SPARQL
 * 2. Формирование URI на основе URI карточки с добавлением #+имя файла
 *    Формирование наименование на основе имени файла
 * 
 * Проверка на основе двух полей (accessURL и downloadURL)
 * https://stackoverflow.com/questions/70067400/manually-validate-antd-form-field-against-another-field
 * 
 * graph - iri графа, который содержит данные
 */
const showNew = (formRef=f=>f, factory, onFinishOperation=f=>f, onCancelOperation=f=>f, assetURI, graph) => {
  const extra =[
    //см. https://www.w3.org/TR/vocab-dcat-3/#Property:distribution_access_url
    { "uri": "http://www.w3.org/ns/dcat#accessURL", 
      rules: [
        { required: false, message: "URL-адрес ресурса, который предоставляет доступ к распределению набора данных. Например, целевая страница, фид, конечная точка SPARQL." }, 
        (formInstance) => ({
          message: 'Должно быть заполнен либо URL-адрес ресурса (URL доступа), либо URL загружаемого файла (скачать)',
          validator: async (_, value) => {
            const downloadURL = formInstance.getFieldValue("http://www.w3.org/ns/dcat#downloadURL");
            if ((!downloadURL || downloadURL.length === 0) && (!value || value.length === 0)){
              return Promise.reject(new Error());
             }
            return Promise.resolve();
          },
        }),
        { type: 'url', warningOnly: true }, 
        { type: 'string', min: 6 }
      ]
    },
    //см. 
    { "uri": "http://www.w3.org/ns/dcat#byteSize",
      "style": "{{ width: '100%' }}",
    },
    //см.  https://www.w3.org/TR/vocab-dcat-3/#Property:distribution_download_url
    { "uri": "http://www.w3.org/ns/dcat#downloadURL", 
      rules: [
        { required: false, message: "URL загружаемого файла в заданном формате. Например, файл CSV или файл RDF." }, 
        (formInstance) => ({
          message: 'Должно быть заполнен либо URL-адрес ресурса (URL доступа), либо URL загружаемого файла (скачать)',
          validator: async (_, value) => {
            const accessURL = formInstance.getFieldValue("http://www.w3.org/ns/dcat#accessURL");
            if ((!accessURL || accessURL.length === 0) && (!value || value.length === 0)){
              return Promise.reject(new Error());
             }
            return Promise.resolve();
          },
        }),
        { type: 'url', warningOnly: true }, 
        { type: 'string', min: 6 }
      ]
    },
    //см. 
    { "uri": "http://purl.org/dc/terms/issued", 
      rules:[{ required: true, message: 'Пожалуйста, укажите дату официального выпуска (например, публикации) распространения!' }]
    },
    //см. 
    { "uri": "http://purl.org/dc/terms/description"},
  ];
  const tail = [
    {
      "type": "link", 
      "htmlType": "button", 
      "text": "Заполнить для графа в Virtuoso",
      "disabled": (graph == undefined) || !graph.startsWith("http"),
      "onClick": () => onFillSparql(formRef, assetURI, graph)
    }, 
    {
      "type": "link", 
      "htmlType": "button", 
      "text": 'Заполнить из "Скачать"',
      "disabled": false,
      "onClick": () => onFillFile(formRef, assetURI)
    }, 
  ];
	return (
    <Modal style={{minWidth: 700}} open={true}
        title={i18n.t('components.adms.distribution.new.title')}
        cancelText={i18n.t('components.adms.distribution.new.cancelText')}
        okText={i18n.t('components.adms.distribution.new.okText')} 
        onCancel={onCancelOperation} onOk={onFinishOperation}>	
        <NewElement 
          formRef={formRef} 
          factory={factory} 
          rdfType={"http://www.w3.org/ns/dcat#Distribution"} 
          prefixURI={makeHashLastInURI(assetURI)}
          extra={extra} 
          tail={tail}
          />
	  </Modal>
  )
}

/** Заполняет форму создания нового распространения для SPARQL запроса */
const onFillSparql = (formInstance, assetURI, graph) => {
  //console.log("AssetDistributions.js ", formInstance);
  const accessURL = settings.endpointUrl+'?default-graph-uri='+encodeURIComponent(graph)+'&query=construct+%7B%3Fs+%3Fp+%3Fo%7D+where+%7B%3Fs+%3Fp+%3Fo%7D&format=text%2Fplain&should-sponge=&timeout=0&signal_void=on';
  formInstance.current.setFieldsValue({
    "IRI": makeHashLastInURI(assetURI)+"SPARQL",
    "http://www.w3.org/2000/01/rdf-schema#label": {text: "Получение содержимого SPARQL запросом", lang: ""},
    "http://www.w3.org/ns/dcat#accessURL": accessURL,
    "http://purl.org/dc/terms/issued": moment(),
    "http://purl.org/dc/terms/description": 'Для получения содержимого из графа "'+graph+'" можно использовать SPARQL запрос select ?s ?p ?o where {?s ?p ?o} или construct {?s ?p ?o} where {?s ?p ?o}',
    "http://www.w3.org/ns/dcat#downloadURL": '',
  });
  fetch(accessURL, {method: 'HEAD'})
    .then (response => {
      //console.log("AssetDistributions.js onFillSparql", response);
      if (response.ok){
        const fileSizeString = response.headers.get('Content-Length');
        if (fileSizeString){
          //console.log("AssetDistributions.js onFillSparql", fileSizeString, parseInt(fileSizeString, 10));
          formInstance.current.setFieldsValue({
            "http://www.w3.org/ns/dcat#byteSize": parseInt(fileSizeString, 10),
          });  
        }
      };
    })
};

/** Заполняет форму создания нового распространения для файла */
const onFillFile = (formInstance, assetURI) => {
  //console.log("AssetDistributions.js onFillFile", formInstance);
  const downloadURL = formInstance.current.getFieldValue("http://www.w3.org/ns/dcat#downloadURL");
  if (downloadURL == undefined || !downloadURL || !downloadURL.startsWith("http")){
    message.error(i18n.t('components.adms.distribution.message.not_downloadURL'));
    return;
  }
  const fileName = parseFileNameFromURL(downloadURL);
  formInstance.current.setFieldsValue({
    "IRI": makeHashLastInURI(assetURI)+fileName,
    "http://www.w3.org/2000/01/rdf-schema#label": {text: fileName, lang: ""},
    "http://purl.org/dc/terms/issued": moment(),
    "http://purl.org/dc/terms/description": 'Содержимое элемента каталога доступно по ссылке в поле "Скачать"',    
  });
  //Получить информацию о файле запросом см.
  //https://stackoverflow.com/questions/47240975/how-to-fetch-using-fetch-api-only-headers-in-javascript-not-the-whole-content
  fetch(downloadURL, {method: 'HEAD', credentials: 'include', mode: 'cors', redirect: 'follow'})
    .then (response => {
      //console.log("AssetDistributions.js onFillFile", response, response.status);
      if (response.status === 302) {
        const newLocation = res.headers.get("location");
        console.log("AssetDistributions.js onFillFile", newLocation);
        //const newUrl = await fetch(newLocation);
      }
      // console.log("AssetDistributions.js onFillFile", response, response.url, response.url != downloadURL);
      // if (response.url != downloadURL){
      //   fetch(downloadURL, {method: 'HEAD', credentials: 'include', mode: 'cors', redirect: 'manual'})
      //     .then (response2 => {
      //       console.log("AssetDistributions.js onFillFile", response2, response2.url, response2.url != downloadURL);
      //       if (response2.ok){
      //         const fileSizeString = response2.headers.get('Content-Length');
      //         if (fileSizeString){
      //           console.log("AssetDistributions.js onFillSparql", fileSizeString, parseInt(fileSizeString, 10));
      //           formInstance.current.setFieldsValue({
      //             "http://www.w3.org/ns/dcat#byteSize": parseInt(fileSizeString, 10),
      //           });  
      //         }
      //       }
      //   });
      //   return;
      // }
      if (response.ok){
        const fileSizeString = response.headers.get('Content-Length');
        //console.log("AssetDistributions.js onFillFile", fileSizeString);
        if (fileSizeString){
          //console.log("AssetDistributions.js onFillSparql", fileSizeString, parseInt(fileSizeString, 10));
          formInstance.current.setFieldsValue({
            "http://www.w3.org/ns/dcat#byteSize": parseInt(fileSizeString, 10),
          });  
        }
      }
    })
 };

/** Преобразовать данные из формы в строковые значения  */
const valueToString = (value, predicat) =>{
  //проверка, что moment см. https://stackoverflow.com/questions/36457220/how-to-test-if-a-variable-is-a-moment-js-object
  if (value instanceof moment){
    return value.format("yyyy-MM-DD")
  }
  if (["http://www.w3.org/ns/dcat#downloadURL", "http://www.w3.org/ns/dcat#accessURL"].includes(predicat)){
    return ""+value;
  }
  return ""+value;
}

/** 
 * Отображение распространение элемента каталога.
 * Распространение может быть как через endpoint (с использованием SPRQL запроса), так и с помощью файла 
 */
class AssetDistributions extends React.Component {
  state = {
    loading: false,
    operation: 'view',
    //Граф, в котором лежат данные для распространения (для создания распространения на основе SPARQL запроса)
    graph: undefined
  }

  formRef = React.createRef();


  componentDidMount() {
    this.loadDetails();
  }

  /** Необходимо понять, наличие детальной информации о распространение актива.
   * Первоначально загружается только ссылка на distribution, нужно дать детальную информацию. 
   */
  componentWillReceiveProps(nextProps){
    const {distributions} = nextProps;
    //Есть незагруженное описания распространения актива
    if (distributions && Array.isArray(distributions) && (distributions.filter(d=> d.state!="loaded").length>0))
      this.loadDetails(distributions);
  }

  loadDetails(items=null) {
    const {distributions, lang, graph, onLoadDetailDistribution} = this.props;
    this.setState({loading: true});
    const values = (items)?items:distributions;
    //Получаем список ссылок
    const data = subsetByLang(values, lang);
    const requests = data.map(distribution => RdfTriplet.loadSubject(distribution.object.value, graph));
    //Получим описание всех элементов и обновим distributions
    Promise.all(requests).then(result => {
       result.forEach(distribution => {
          //определим исходный источник, т.к. нужно указать в параметрах lang, для которого нужно сделать обновление
          const sources = data.filter(item => item.object.value == distribution.subject);
          const findLang = (sources && (sources.length>0))? getLangValue(sources[0]): undefined;
          updateTripletsByObjectValue({values: distribution.bindings, state: "loaded"}, values, distribution.subject, findLang);
       });
       onLoadDetailDistribution(AdmsAsset, values);
       this.setState({loading: false});
    }).catch( e => {
      data.forEach(distribution => {
        updateTripletsByObjectValue({state: "error"}, values, distribution.object.value);
      });
      onLoadDetailDistribution(AdmsAsset, values);
      this.setState({loading: false});
      //`Ошибка при получении дополнительной информации и распространении элемента каталога. ${e}`)
      message.error(i18n.t('components.adms.distribution.message.e_detail', {detail: e}));
    });
    this.loadGraphState();
  };
    
  /** Загружает информацию о наличии графов в БД Virtuoso */
  loadGraphState(){
    const {lang, graphs, onCheckGraphState} = this.props;
    const presents = graphs.filter(graph=> graph.state == "present");
    if (presents.length>0){
      this.setState({graph: presents[0].iri});
      return;
    }
    const requests = graphs
      .filter(graph=> graph.state == "recommended")
      .map(graph => onCheckGraphState(AdmsAsset, graph.iri));
    //console.log("AssetDistributions.js loadGraphState", graphs, requests);
    Promise.all(requests).then(result => {
      //console.log("AssetDistributions.js loadGraphState then", result);
      result.forEach(graph => {
        if (graph.state == "present"){
          this.setState({graph: graph.iri});
          return;    
        }
     });
    }).catch( e => {
      console.log("AssetDistributions.js loadGraphState catch", e);
    })
  };

  handleDetailDistribution (e, IRI) {
    //console.log("AssetDistributions.js", this, IRI);
    e.preventDefault();
    const { operation } = this.props;
    this.setState({modal: (operation == "edit")? "edit":"view", selected: IRI});
  };

  /** Удаление Distribution */
  handleDeleteDistribution (e, IRI, header) {
    e.preventDefault();
    //console.log("handleDeleteDistribution (e, IRI)", IRI, e);
    const { asset, onDeleteElement } = this.props;
    confirm({ title: i18n.t('components.adms.distribution.unlink.title'), content: header, 
    okText: i18n.t('components.adms.distribution.unlink.okText'), okType: 'danger', 
    cancelText: i18n.t('components.adms.distribution.unlink.cancelText'),
      onOk() { 
        onDeleteElement(AdmsAsset, asset, IRI)
          .then (result =>{
              //console.log("onDeleteElement", result);
              message.success(i18n.t('components.adms.distribution.message.ok_unlink'));
          })
      },
      onCancel() {},
    });
//this.setState({modal:"view", selected: IRI});
  };

  handleOperation (e, IRI, operation) {
    //console.log("AssetDistributions.js", this, IRI, operation);
    e.preventDefault();
    if (operation == 'edit')
      this.setState({modal:"edit", selected: IRI});
    if (operation == 'translate')
      this.setState({modal:"translate", selected: IRI});
  };

  cancelOperation(){
    this.setState({modal:"none"});
  }

  /** Запускает добавление новой связи  */
  submitOperation() {
    //console.log('submitOperation() ', this.props.selected);
    const { asset, lang, selected, onAddElement} = this.props;
    const IRI = asset+"_distribution_"+selected.fileEntryId;
    const url = encodeURI("http://62.61.8.56:8080/documents/"+selected.groupId+"/"+selected.folderId+"/"+selected.fileName+"/"+selected.uuid);
    onAddElement(AdmsAsset, asset, IRI, selected.title, selected.description, '"'+url+'"', lang)
      .then (result =>{
          //console.log("onAddElement", result);
          message.success(i18n.t('components.adms.distribution.message.ok_link'));
        })
    this.setState({modal:"none"});
  };

  /** Запускает добавление нового  элемента и установка связи */
  submitNewOperation() {
    const { asset, onNewElement, onInsertProperty} = this.props;
    //console.log('AssetDistributions.js submitNewOperation() ', this.formRef);
    const form  = this.formRef.current;      
    form.validateFields()
      .then( values => {
        const IRI = (values.IRI.startsWith("http://") || values.IRI.startsWith("https://"))? values.IRI : "http://www.w3.org/ns/dcat#"+values.IRI;
        //Исключаем служебные элементы
        const updateKeys = Object.keys(values)
          .filter(key => !['IRI', 'http://www.w3.org/2000/01/rdf-schema#label', 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type'].includes(key))
          //Исключаем пустые значения
          .filter(key => values[key] != null && values[key] != undefined && values[key] != '');
        const requests = updateKeys
          .map(key => onInsertProperty(AdmsAsset, IRI, key, valueToString(values[key])));
        //console.log("AssetDistributions.js submitNewOperation() Received values of form: ", values, IRI, updateKeys, requests);
        const label = values["http://www.w3.org/2000/01/rdf-schema#label"];
        onNewElement(AdmsAsset, asset, IRI, label.text, label.lang)
          .then (result =>{
            if (requests.length<1)
              message.success(i18n.t('components.adms.distribution.message.ok_new'));
            else
              Promise.all(requests)
                .then(result2 => {
                  //console.log("AssetDistributions.js submitNewOperation() result2 ", result2);
                  message.success(i18n.t('components.adms.distribution.message.ok_new'));
                });
          })
          // .catch(info => {
          //   message.error(i18n.t('components.adms.distribution.message.e_new', {detail: info}));
          // });
        this.setState({modal:"none"});
      })
      .catch(info => {
        console.log("AssetDistributions.js submitNewOperation() Received info of form: ", info);
        message.error(i18n.t('components.adms.distribution.message.e_new', {detail: info}));
      });
  };


  onAction (e, type, item) {
    e.preventDefault();
    if (type=="add")
      this.props.onLoadItems()
        .then(response => {
          //console.log("result", response);
          this.setState({modal:"add"});
        })
        .catch(e => {
          message.error(i18n.t('components.adms.distribution.message.e_search', {detail: e}));//`Ошибка при поиске файлов. ${e}`); 
        });
    if (type=="new")
      this.setState({modal:"new"});
  };

  render() {
    //console.log(this);
    const { modal, loading, selected, graph} = this.state;
    const { distributions, factory, history, asset } = this.props;
    const hasDistribution = (distributions && Array.isArray(distributions) && distributions.length>0);
    const isModified = this.props.operation == "edit";
    return (
      <div className="ant-list ant-list-split demo-loadmore-list css-dev-only-do-not-override-xbngoj css-var-root">
        {isModified && <div class="ant-btn-group" style={{background: "rgb(128, 128, 128)"}}>
            <Button type="dashed" size="small" icon={<EditOutlined />} ghost onClick={(e)=> this.onAction(e, "add")}>Связать</Button>
            <Button type="dashed" size="small" icon={<FileAddOutlined />} ghost onClick={(e)=> this.onAction(e, "new")}>Создать</Button>
           </div>
        }
        {(modal=="add" ) && 
          showAdd( this.formRef, ()=>this.submitOperation(), ()=>this.cancelOperation(), this.props.selected)
        }
        {(modal=="new" ) && 
          showNew( this.formRef, factory, ()=>this.submitNewOperation(), ()=>this.cancelOperation(), asset, graph)
        }
        {(modal=="edit" || modal=="translate") && 
          showEditDetail(this.formRef, selected, factory, history, ()=>this.cancelOperation(), ()=>this.cancelOperation(), modal)
        }
        {(modal=="view" )&& showViewDetail(this.formRef, selected, factory, history, ()=>this.cancelOperation(), ()=>this.cancelOperation())}
        {!hasDistribution &&
          <ul class="ant-list-items" style={{"listStyle": "none", "padding": "0"}}>
            <li class="ant-list-item">
              <div class="ant-list-item-meta">
                <div class="ant-list-item-meta-content">
                  <h4 class="ant-list-item-meta-title"><span class="csi_cat_title">{i18n.t('components.adms.distribution.title')}</span></h4>
                  <h4 class="ant-list-item-meta-title"><b>{i18n.t('components.adms.distribution.nolinks')}</b><br />{i18n.t('components.adms.distribution.nofiles')}</h4>
                </div>
              </div>
            </li>
          </ul> 
        }
        {hasDistribution && 
          <ul class="ant-list-items" style={{"listStyle": "none", "padding": "0", "display": "grid"}}>
            <li class="ant-list-item" style={{borderBottomRightRadius: 0, borderBottomLeftRadius: 0}}>
              <div class="ant-list-item-meta">
                <div class="ant-list-item-meta-content">
                  <h4 class="ant-list-item-meta-title"><span class="csi_cat_title">{i18n.t('components.adms.distribution.title')}</span></h4>
                </div>
              </div>
            </li>
            {distributions.map(item => 
                    <AssetDistributionListItem 
                      distribution={item} factory={factory} 
                      onClick={(e, iri) => this.handleDetailDistribution(e, iri)}
                      onDelete={(e, iri, header) => this.handleDeleteDistribution(e, iri, header)}
                      onSelectOperation={(e, iri, operation)=> this.handleOperation(e, iri, operation)}
                      canDeleted={isModified}
                    />
                  )}
        </ul> 
        }
        </div>
    );
  }
}

//Представление списка AssetDistribution
export default connect(
  (state, props) => {
    const {vset, vasset, ldml} = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      distributions: vasset.distributions,      //Текущие данные
      asset:  vasset.iri,
      graphs: vasset.graphs,
      selected: ldml.file,
    })
  },
  dispatch => ({
    onAddElement (actions, asset, iri, label, description, url, lang){
      return dispatch(actions.addDistribution(asset, iri, label, description, url, lang));
    },
    onNewElement (actions, asset, iri, label, lang){
      return dispatch(actions.addDistributionSimple(asset, iri, label, lang));
    },    
    onDeleteElement (actions, asset, iri){
      return dispatch(actions.deleteDistribution(asset, iri));
    },
    onLoadDetailDistribution (actions, values){
      return dispatch(actions.LOAD_DISTRIBUTIONS(values));
    },
    onLoadItems(){
      return dispatch(DMLActions.loadItems());
    },
    onCheckGraphState(actions, graph){
      return dispatch(actions.checkGraphState(graph));
    },
    onInsertProperty(actions, subject, predicat, value, lang=undefined){
      return dispatch(actions.insertTriple(subject, predicat, value, lang));
    }
  })
)(AssetDistributions)
